var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataArtwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_25330",
    x: 6.5,
    y: 20.131,
    width: 83.873,
    height: 76.938,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d4d9e8",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-no_data_artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no_data_artwork",
    clipPath: "url(#clip-no_data_artwork)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9917",
    "data-name": "Group 9917",
    transform: "translate(-1029 -518)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1185",
    "data-name": "Ellipse 1185",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1084 530)",
    fill: "#e6f5f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9506",
    "data-name": "Group 9506",
    transform: "translate(1037.5 540.131)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.5, -22.13)",
    filter: "url(#Rectangle_25330)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25330-2",
    "data-name": "Rectangle 25330",
    width: 71.874,
    height: 64.937,
    rx: 4,
    transform: "translate(8.5 22.13)",
    fill: "#fcfdfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505",
    transform: "translate(7.728 8.417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25331",
    "data-name": "Rectangle 25331",
    width: 45.211,
    height: 3.864,
    rx: 1.932,
    transform: "translate(11.206 1.932)",
    fill: "#e4e7eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9498",
    "data-name": "Group 9498",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336",
    "data-name": "Rectangle 25336",
    width: 7.728,
    height: 7.728,
    rx: 2,
    fill: "#20bead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21168",
    "data-name": "Path 21168",
    d: "M100.134,55.211h0a.193.193,0,0,1-.148-.067l-1.015-1.1a.2.2,0,0,1,.3-.269l.874.948,2.421-2.414a.2.2,0,0,1,.282,0,.2.2,0,0,1,0,.282l-2.569,2.562A.183.183,0,0,1,100.134,55.211Z",
    transform: "translate(-97.036 -49.838)",
    fill: "#fcfdfe",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9503",
    "data-name": "Group 9503",
    transform: "translate(7.728 35.852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25334",
    "data-name": "Rectangle 25334",
    width: 45.211,
    height: 3.864,
    rx: 1.932,
    transform: "translate(11.206 1.932)",
    fill: "#e4e7eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9501",
    "data-name": "Group 9501",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336-2",
    "data-name": "Rectangle 25336",
    width: 7.728,
    height: 7.728,
    rx: 2,
    fill: "#20bead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21168-2",
    "data-name": "Path 21168",
    d: "M100.134,55.211h0a.193.193,0,0,1-.148-.067l-1.015-1.1a.2.2,0,0,1,.3-.269l.874.948,2.421-2.414a.2.2,0,0,1,.282,0,.2.2,0,0,1,0,.282l-2.569,2.562A.183.183,0,0,1,100.134,55.211Z",
    transform: "translate(-97.036 -49.838)",
    fill: "#fcfdfe",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504",
    transform: "translate(7.728 21.941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25332",
    "data-name": "Rectangle 25332",
    width: 45.211,
    height: 3.864,
    rx: 1.932,
    transform: "translate(11.206 1.932)",
    fill: "#e4e7eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9499",
    "data-name": "Group 9499",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336-3",
    "data-name": "Rectangle 25336",
    width: 7.728,
    height: 7.728,
    rx: 2,
    fill: "#20bead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21168-3",
    "data-name": "Path 21168",
    d: "M100.134,55.211h0a.193.193,0,0,1-.148-.067l-1.015-1.1a.2.2,0,0,1,.3-.269l.874.948,2.421-2.414a.2.2,0,0,1,.282,0,.2.2,0,0,1,0,.282l-2.569,2.562A.183.183,0,0,1,100.134,55.211Z",
    transform: "translate(-97.036 -49.838)",
    fill: "#fcfdfe",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9502",
    "data-name": "Group 9502",
    transform: "translate(7.728 49.377)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25333",
    "data-name": "Rectangle 25333",
    width: 45.211,
    height: 3.864,
    rx: 1.932,
    transform: "translate(11.206 1.932)",
    fill: "#e4e7eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9500",
    "data-name": "Group 9500",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336-4",
    "data-name": "Rectangle 25336",
    width: 7.728,
    height: 7.728,
    rx: 2,
    fill: "#20bead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21168-4",
    "data-name": "Path 21168",
    d: "M100.134,55.211h0a.193.193,0,0,1-.148-.067l-1.015-1.1a.2.2,0,0,1,.3-.269l.874.948,2.421-2.414a.2.2,0,0,1,.282,0,.2.2,0,0,1,0,.282l-2.569,2.562A.183.183,0,0,1,100.134,55.211Z",
    transform: "translate(-97.036 -49.838)",
    fill: "#fcfdfe",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataArtwork);
export default __webpack_public_path__ + "static/media/no_data_artwork.c43ca210523019ca28270a568239aae0.svg";
export { ForwardRef as ReactComponent };